.page {
  padding: var(--haus-quickOrder__page__padding, 2rem);
  max-width: var(--haus-quickOrder__page__max-width, 50rem);
  margin: var(--haus-quickOrder__page__margin, 0 auto);
}

.container {
  background: var(--haus-quickOrder__container__background, #fff);
  border-radius: var(--haus-quickOrder__container__border-radius, 0.75rem);
  box-shadow: var(--haus-quickOrder__container__box-shadow, 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1));
  padding: var(--haus-quickOrder__container__padding, 2rem);
}

.modeTabs {
  display: var(--haus-quickOrder__modeTabs__display, flex);
  gap: var(--haus-quickOrder__modeTabs__gap, 0);
  margin-bottom: var(--haus-quickOrder__modeTabs__margin-bottom, 1.5rem);
  border-bottom: var(--haus-quickOrder__modeTabs__border-bottom, 0.125rem solid #eee);
}

.modeTab,
.modeTabActive {
  display: var(--haus-quickOrder__modeTab__display, flex);
  align-items: var(--haus-quickOrder__modeTab__align-items, center);
  gap: var(--haus-quickOrder__modeTab__gap, 0.5rem);
  padding: var(--haus-quickOrder__modeTab__padding, 0.75rem 1.5rem);
  border: var(--haus-quickOrder__modeTab__border, none);
  border-bottom: var(--haus-quickOrder__modeTab__border-bottom, 2px solid transparent);
  margin-bottom: var(--haus-quickOrder__modeTab__margin-bottom, -2px);
  background: var(--haus-quickOrder__modeTab__background, transparent);
  color: var(--haus-quickOrder__modeTab__color, #666);
  font-size: var(--haus-quickOrder__modeTab__font-size, 0.95rem);
  cursor: var(--haus-quickOrder__modeTab__cursor, pointer);
  transition: var(--haus-quickOrder__modeTab__transition, color 0.2s, border-color 0.2s);
  min-height: var(--haus-quickOrder__modeTab__min-height, 2.75rem);

  &:focus-visible {
    outline: var(
      --haus-quickOrder__modeTab__focus-visible__outline,
      2px solid var(--haus-color-primary, #000)
    );
    outline-offset: var(--haus-quickOrder__modeTab__focus-visible__outline-offset, 2px);
  }
}

.modeTabActive {
  color: var(--haus-quickOrder__modeTabActive__color, #4a90d9);
  border-bottom-color: var(--haus-quickOrder__modeTabActive__border-color, #4a90d9);
  font-weight: var(--haus-quickOrder__modeTabActive__font-weight, 600);
}

.form {
  display: var(--haus-quickOrder__form__display, flex);
  flex-direction: var(--haus-quickOrder__form__flex-direction, column);
  gap: var(--haus-quickOrder__form__gap, 0);
  width: var(--haus-quickOrder__form__width, 100%);
}

.resultMessageSuccess,
.resultMessageError {
  padding: var(--haus-quickOrder__resultMessage__padding, 1rem);
  border-radius: var(--haus-quickOrder__resultMessage__border-radius, 0.5rem);
  margin-bottom: var(--haus-quickOrder__resultMessage__margin-bottom, 1.5rem);
}

.resultMessageSuccess {
  background: var(--haus-quickOrder__resultMessageSuccess__background, #e8f5e9);
  border: var(--haus-quickOrder__resultMessageSuccess__border, 1px solid #4caf50);
}

.resultMessageError {
  background: var(--haus-quickOrder__resultMessageError__background, #ffebee);
  border: var(--haus-quickOrder__resultMessageError__border, 1px solid #f44336);
}

.successContent {
  display: var(--haus-quickOrder__successContent__display, flex);
  color: var(--haus-quickOrder__successContent__color, #2e7d32);
}

.errorSummary {
  display: var(--haus-quickOrder__errorSummary__display, block);
}

.errorList {
  margin: var(--haus-quickOrder__errorList__margin, 0.5rem 0 0 0);
  padding-left: var(--haus-quickOrder__errorList__padding-left, 1.25rem);
  color: var(--haus-quickOrder__errorContent__color, #c62828);
}

.manualPanel,
.csvPanel {
  display: var(--haus-quickOrder__manualPanel__display, flex);
  flex-direction: var(--haus-quickOrder__manualPanel__flex-direction, column);
  width: var(--haus-quickOrder__manualPanel__width, 100%);
}

.formHeader {
  display: grid;
  grid-template-columns: var(--haus-quickOrder__formHeader__grid-columns, 1fr 7.5rem 3.125rem);
  gap: var(--haus-quickOrder__formHeader__gap, 1rem);
  padding: var(--haus-quickOrder__formHeader__padding, 0.75rem 0);
  border-bottom: var(--haus-quickOrder__formHeader__border-bottom, 0.125rem solid #eee);
  margin-bottom: var(--haus-quickOrder__formHeader__margin-bottom, 0.5rem);
}

.columnHeaderSku,
.columnHeaderQuantity,
.columnHeaderActions {
  font-weight: var(--haus-quickOrder__columnHeader__font-weight, 600);
  color: var(--haus-quickOrder__columnHeader__color, #666);
  font-size: var(--haus-quickOrder__columnHeader__font-size, 0.875rem);
  text-transform: var(--haus-quickOrder__columnHeader__text-transform, uppercase);
}

.formRows {
  margin-bottom: var(--haus-quickOrder__formRows__margin-bottom, 1rem);
}

.formRow {
  display: var(--haus-quickOrder__formRow__display, grid);
  grid-template-columns: var(--haus-quickOrder__formRow__grid-columns, 1fr 7.5rem 3.125rem);
  column-gap: var(--haus-quickOrder__formRow__column-gap, 0.75rem);
  row-gap: var(--haus-quickOrder__formRow__row-gap, 0.5rem);
  padding: var(--haus-quickOrder__formRow__padding, 0.5rem 0);
  align-items: var(--haus-quickOrder__formRow__align-items, center);
}

@media (max-width: 37.5rem) {
  .formHeader {
    grid-template-columns: 1fr;
    row-gap: var(--haus-quickOrder__formHeaderMobile__row-gap, 0.5rem);
  }

  .formRow {
    grid-template-columns: 1fr;
    row-gap: var(--haus-quickOrder__formRowMobile__row-gap, 0.5rem);
  }

  .inputCellActions {
    display: flex;
    justify-content: flex-end;
  }
}

.inputCellSku,
.inputCellQuantity,
.inputCellActions {
  box-sizing: border-box;

  input {
    box-sizing: border-box;
    width: var(--haus-quickOrder__input__width, 100%);
    padding: var(--haus-quickOrder__input__padding, 0.75rem);
    border: var(--haus-quickOrder__input__border, 0.0625rem solid #ddd);
    border-radius: var(--haus-quickOrder__input__border-radius, 0.375rem);
    font-size: var(--haus-quickOrder__input__font-size, 1rem);
    transition:
      border-color 0.2s,
      box-shadow 0.2s;
  }

  input:focus-visible {
    outline: var(--haus-quickOrder__inputFocus__outline, 2px solid var(--haus-color-primary, #000));
    outline-offset: var(--haus-quickOrder__inputFocus__outline-offset, 2px);
    border-color: var(--haus-quickOrder__inputFocus__border-color, #4a90d9);
    box-shadow: var(
      --haus-quickOrder__inputFocus__box-shadow,
      0 0 0 0.1875rem rgba(74, 144, 217, 0.1)
    );
  }

  input:disabled {
    background: var(--haus-quickOrder__inputDisabled__background, #f5f5f5);
    cursor: not-allowed;
  }
}

.inputCellActions {
  display: flex;
  justify-content: flex-end;
}

.inputCellQuantity input {
  text-align: var(--haus-quickOrder__inputCellQuantity__text-align, center);
}

.removeButton {
  display: var(--haus-quickOrder__removeButton__display, flex);
  align-items: var(--haus-quickOrder__removeButton__align-items, center);
  justify-content: var(--haus-quickOrder__removeButton__justify-content, center);
  width: var(--haus-quickOrder__removeButton__width, 2.75rem);
  height: var(--haus-quickOrder__removeButton__height, 2.75rem);
  border: var(--haus-quickOrder__removeButton__border, none);
  background: var(--haus-quickOrder__removeButton__background, #ffebee);
  color: var(--haus-quickOrder__removeButton__color, #f44336);
  border-radius: var(--haus-quickOrder__removeButton__border-radius, 0.375rem);
  cursor: var(--haus-quickOrder__removeButton__cursor, pointer);
  transition: var(--haus-quickOrder__removeButton__transition, background 0.2s);
}

.removeButton:disabled {
  opacity: var(--haus-quickOrder__removeButtonDisabled__opacity, 0.3);
  cursor: var(--haus-quickOrder__removeButtonDisabled__cursor, not-allowed);
}

.addRowButton {
  display: var(--haus-quickOrder__addRowButton__display, flex);
  align-items: var(--haus-quickOrder__addRowButton__align-items, center);
  justify-content: var(--haus-quickOrder__addRowButton__justify-content, center);
  gap: var(--haus-quickOrder__addRowButton__gap, 0.5rem);
  padding: var(--haus-quickOrder__addRowButton__padding, 0.75rem 1rem);
  border: var(--haus-quickOrder__addRowButton__border, 0.125rem dashed #ddd);
  background: var(--haus-quickOrder__addRowButton__background, transparent);
  color: var(--haus-quickOrder__addRowButton__color, #666);
  border-radius: var(--haus-quickOrder__addRowButton__border-radius, 0.375rem);
  cursor: var(--haus-quickOrder__addRowButton__cursor, pointer);
  width: var(--haus-quickOrder__addRowButton__width, 100%);
  font-size: var(--haus-quickOrder__addRowButton__font-size, 0.9rem);
  transition:
    border-color 0.2s,
    color 0.2s;
  margin-bottom: var(--haus-quickOrder__addRowButton__margin-bottom, 1.5rem);
  min-height: var(--haus-quickOrder__addRowButton__min-height, 2.75rem);
}

.addRowButton:disabled {
  opacity: 0.5;
  cursor: var(--haus-quickOrder__addRowButtonDisabled__cursor, not-allowed);
}

.formActions {
  display: var(--haus-quickOrder__formActions__display, flex);
  gap: var(--haus-quickOrder__formActions__gap, 1rem);
  justify-content: var(--haus-quickOrder__formActions__justify-content, flex-end);
  flex-wrap: var(--haus-quickOrder__formActions__flex-wrap, wrap);
}

.submitButton {
  flex: var(--haus-quickOrder__submitButton__flex, 0 0 auto);
  display: var(--haus-quickOrder__submitButton__display, flex);
  align-items: var(--haus-quickOrder__submitButton__align-items, center);
  justify-content: var(--haus-quickOrder__submitButton__justify-content, center);
  gap: var(--haus-quickOrder__submitButton__gap, 0.5rem);
  padding: var(--haus-quickOrder__submitButton__padding, 1rem 1.5rem);
  border: var(--haus-quickOrder__submitButton__border, none);
  background: var(--haus-quickOrder__submitButton__background, #4a90d9);
  color: var(--haus-quickOrder__submitButton__color, #fff);
  border-radius: var(--haus-quickOrder__submitButton__border-radius, 0.5rem);
  font-size: var(--haus-quickOrder__submitButton__font-size, 1rem);
  font-weight: var(--haus-quickOrder__submitButton__font-weight, 600);
  cursor: var(--haus-quickOrder__submitButton__cursor, pointer);
  transition: var(--haus-quickOrder__submitButton__transition, background 0.2s);
}

.submitButton:disabled {
  background: var(--haus-quickOrder__submitButtonDisabled__background, #ccc);
  cursor: var(--haus-quickOrder__submitButtonDisabled__cursor, not-allowed);
}

.clearButton {
  padding: var(--haus-quickOrder__clearButton__padding, 1rem 1.5rem);
}

.spinner {
  display: var(--haus-quickOrder__spinner__display, inline-block);
  width: var(--haus-quickOrder__spinner__width, 1.125rem);
  height: var(--haus-quickOrder__spinner__height, 1.125rem);
  border: var(--haus-quickOrder__spinner__border, 0.125rem solid rgba(255, 255, 255, 0.3));
  border-top-color: var(--haus-quickOrder__spinner__border-top-color, #fff);
  border-radius: var(--haus-quickOrder__spinner__border-radius, 50%);
  animation: var(--haus-quickOrder__spinner__animation, quickOrderSpin 0.8s linear infinite);
}

@keyframes quickOrderSpin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .modeTab,
  .modeTabActive,
  .submitButton,
  .addRowButton,
  .removeButton,
  .csvTextarea {
    transition: var(--haus-quickOrder__reduced-motion__transition, none);
  }

  .spinner {
    animation: var(--haus-quickOrder__spinner__reduced-motion__animation, none);
  }
}

/* CSV mode */
.csvMode {
  display: var(--haus-quickOrder__csvMode__display, flex);
  flex-direction: var(--haus-quickOrder__csvMode__flex-direction, column);
  gap: var(--haus-quickOrder__csvMode__gap, 1rem);
  width: var(--haus-quickOrder__csvMode__width, 100%);
}

.csvInstructions {
  padding: var(--haus-quickOrder__csvInstructions__padding, 1rem);
  background: var(--haus-quickOrder__csvInstructions__background, #f5f7fa);
  border-radius: var(--haus-quickOrder__csvInstructions__border-radius, 0.5rem);
  font-size: var(--haus-quickOrder__csvInstructions__font-size, 0.9rem);
  color: var(--haus-quickOrder__csvInstructions__color, #555);
}

.csvInstructions p {
  margin: var(--haus-quickOrder__csvInstructionsP__margin, 0 0 0.5rem 0);
}

.code {
  background: var(--haus-quickOrder__code__background, #e8eef4);
  padding: var(--haus-quickOrder__code__padding, 0.2rem 0.5rem);
  border-radius: var(--haus-quickOrder__code__border-radius, 0.25rem);
  font-family: var(--haus-quickOrder__code__font-family, monospace);
  font-size: var(--haus-quickOrder__code__font-size, 0.85rem);
  margin-right: var(--haus-quickOrder__code__margin-right, 0.5rem);
}

.csvTextarea {
  border: var(--haus-quickOrder__csvTextarea__border, 0.0625rem solid #ddd);
  border-radius: var(--haus-quickOrder__csvTextarea__border-radius, 0.5rem);
  font-family: var(--haus-quickOrder__csvTextarea__font-family, monospace);
  font-size: var(--haus-quickOrder__csvTextarea__font-size, 0.9rem);
  resize: var(--haus-quickOrder__csvTextarea__resize, vertical);
  min-height: var(--haus-quickOrder__csvTextarea__min-height, 200px);
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.csvTextarea:focus-visible {
  outline: var(
    --haus-quickOrder__csvTextareaFocus__outline,
    2px solid var(--haus-color-primary, #000)
  );
  outline-offset: var(--haus-quickOrder__csvTextareaFocus__outline-offset, 2px);
  border-color: var(--haus-quickOrder__csvTextareaFocus__border-color, #4a90d9);
  box-shadow: var(
    --haus-quickOrder__csvTextareaFocus__box-shadow,
    0 0 0 0.1875rem rgba(74, 144, 217, 0.1)
  );
}

.csvTextarea:disabled {
  background: var(--haus-quickOrder__csvTextareaDisabled__background, #f5f5f5);
  cursor: var(--haus-quickOrder__csvTextareaDisabled__cursor, not-allowed);
}

.csvErrors {
  display: var(--haus-quickOrder__csvErrors__display, flex);
  flex-direction: var(--haus-quickOrder__csvErrors__flex-direction, column);
  align-items: var(--haus-quickOrder__csvErrors__align-items, flex-start);
  gap: var(--haus-quickOrder__csvErrors__gap, 0.75rem);
  padding: var(--haus-quickOrder__csvErrors__padding, 1rem);
  background: var(--haus-quickOrder__csvErrors__background, #ffebee);
  border: var(--haus-quickOrder__csvErrors__border, 0.0625rem solid #f44336);
  border-radius: var(--haus-quickOrder__csvErrors__border-radius, 0.5rem);
  color: var(--haus-quickOrder__csvErrors__color, #c62828);
}

.csvErrorsTitle,
.csvPreviewTitle {
  font-weight: var(--haus-quickOrder__csvErrorsTitle__font-weight, 700);
}

.csvErrorList {
  margin: var(--haus-quickOrder__csvErrorList__margin, 0.5rem 0 0 0);
  padding-left: var(--haus-quickOrder__csvErrorList__padding-left, 1.25rem);
}

.csvPreview {
  padding: var(--haus-quickOrder__csvPreview__padding, 1rem);
  background: var(--haus-quickOrder__csvPreview__background, #e8f5e9);
  border: var(--haus-quickOrder__csvPreview__border, 0.0625rem solid #4caf50);
  border-radius: var(--haus-quickOrder__csvPreview__border-radius, 0.5rem);
  color: var(--haus-quickOrder__csvPreview__color, #2e7d32);
}

.csvPreviewList {
  margin: var(--haus-quickOrder__csvPreviewList__margin, 0.5rem 0 0 0);
  padding-left: var(--haus-quickOrder__csvPreviewList__padding-left, 1.25rem);
}
